module.exports = __webpack_public_path__ + "media/images/mobile/home/top-253e9b27ee884e88084471772d21c6ba.png";